import React, {Component} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import apis from '../../helper/api'
import swal from 'sweetalert'

let denom_default = "../../swipe/assets/app/media/img/products/denom-default.jpg"
let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

let next_load_url = ""
class ModalDevice extends Component {

    constructor(props) {
        super(props)
        this.state = {
            flag_processing: false,
            flag_processing_search: false,
            platform: 'DESKTOP',
            device_id: '',
            device_info: '',
            device_status: '1',
            search_input: '',
            show_add_form: false,
            data_devices: [],
            error_message: 'Tidak Ada Device yg Terdaftar',
            show_more_btn: false
        }
        this.on_btn_status = this.on_btn_status.bind(this)
        this.on_btn_load_more = this.on_btn_load_more.bind(this)
    }

    componentDidMount() {
        let self = this
        this.get_devices(null, false)
    }

    on_input_change(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    on_select_change(e) {
        this.setState({[e.currentTarget.id] : e.currentTarget.value})
    }

    get_devices(url, is_append) {
        let self = this
        let body = {
            "session_id" : this.props.session,
            "only_active" : false,
            "only_not_active" : false
        }

        if (is_append) {
            this.setState({flag_processing_search: true})
        } else {
            self.setState({data_devices: [], flag_processing_search: true})
        }
        if (url == null) {
            if (this.props.profile.masterid === this.props.data.master_id) {
                url = apis.list_device_agent.replace("{agent_id}", this.props.data.agent_id)
            } else {
                url = apis.list_device_agent_of_downline.replace("{agent_id}", this.props.data.agent_id).replace("{master_id}", this.props.data.master_id)
            }
            url = url.replace('{platform}', 'desktop')
        }
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let new_state = {flag_processing_search: false};
                if (err || !res.ok) {
                    util.log("get_devices", err)
                } else {
                    util.log("get_devices", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                let results = payload.results
                                if (!is_append) {
                                    new_state.data_devices = results.list
                                } else {
                                    var joined = self.state.data_devices.concat(results.list);
                                    new_state.data_devices = joined
                                }
                                if (results.next_page !== null) {
                                    next_load_url = results.next_page.url
                                    new_state.show_more_btn = true
                                } else {
                                    next_load_url = ""
                                    new_state.show_more_btn = false
                                }
                            }
                        } else {
                            new_state.error_message = payload.error.message;
                        }
                    }
                }
                self.setState(new_state);
            })
    }

    on_btn_load_more() {
        if (this.state.tx_flag_processing) return
        if (next_load_url.length !== 0) {
            this.get_devices(next_load_url, true)
        }
    }

    on_add_device(e) {
        if (this.state.device_id.length === 0) {
            swal('Error', 'Periksa kembali form input Anda', 'error')
            return
        }
        let self = this
        let body = {
            "session_id" : this.props.session,
            "device_platform": this.state.platform,
            "device_id": this.state.device_id,
            "device_info": this.state.device_info,
            "device_active": this.state.device_status === '1' ? true : false
        }
        self.setState({flag_processing: true})
        let url = ''
        if (this.props.profile.masterid === this.props.data.master_id) {
            url = apis.add_device_agent.replace("{agent_id}", this.props.data.agent_id)
        } else {
            url = apis.add_device_agent_of_downline.replace("{agent_id}", this.props.data.agent_id).replace("{master_id}", this.props.data.master_id)
        }
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("add_device_agent", err)
                } else {
                    util.log("add_device_agent", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                var joined = self.state.data_devices
                                var new_data = [payload.results].concat(joined)
                                self.setState({data_devices: new_data})
                            }
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                    }
                    self.setState({flag_processing: false})
                }
            })
    }

    on_btn_status(e, item) {
        util.log(e, item)
        let self = this
        swal({
            title: "Konfirmasi",
            text: "Apakah Anda yakin untuk mengubah status device ini?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((sure) => {
            if (sure) {
                let new_status = item.active ? false : true
                let body = {
                    "session_id" : this.props.session,
                    "device_platform": item.platform,
                    "device_id": item.device_id,
                    "device_active": new_status
                }
                let url = ''
                if (this.props.profile.masterid === this.props.data.master_id) {
                    url = apis.change_status_device_agent.replace("{agent_id}", this.props.data.agent_id)
                } else {
                    url = apis.change_status_device_agent_of_downline.replace("{agent_id}", this.props.data.agent_id).replace("{master_id}", this.props.data.master_id)
                }
                request.post(url)
                    .set("Content-Type", "application/json")
                    .send(body)
                    .end(function(err, res) {
                        if (err || !res.ok) {
                            util.log("change_status_device_agent", err)
                        } else {
                            util.log("change_status_device_agent", res);
                            if (res.statusCode == 200) {
                                let payload = res.body
                                if (payload.status == "OK") {
                                    if (payload.results) {
                                        if (payload.results.active === new_status) {
                                            // self.get_devices()
                                            let data = self.state.data_devices
                                            let new_data = []
                                            data.map(function(row, i) {
                                                if (row.item_id === item.item_id) {
                                                    row.active = new_status
                                                }
                                                new_data.push(row)
                                            })
                                            self.setState({data_devices: new_data})
                                        } else {
                                            swal('Error', 'Gagal ubah status', 'error')
                                        }
                                    }
                                } else {
                                    swal("Ups!", payload.error.message, "warning")
                                }
                            } else {
                                swal("Error!", res.statusCode, "warning")
                            }
                        }
                    })
            } else {
                // no-op
            }
        })
    }

    on_btn_search(e) {
        if (this.state.search_input.length === 0) {
            return
        }
        let self = this
        let body = {
            "session_id" : this.props.session,
            "device_id": this.state.search_input
        }
        self.setState({flag_processing_search: true})
        let url = ''
        if (this.props.profile.masterid === this.props.data.master_id) {
            url = apis.search_device_agent.replace("{agent_id}", this.props.data.agent_id)
        } else {
            url = apis.search_device_agent_of_downline.replace("{agent_id}", this.props.data.agent_id).replace("{master_id}", this.props.data.master_id)
        }
        url = url.replace('{platform}', 'desktop')
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("search_device_agent", err)
                } else {
                    util.log("search_device_agent", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                self.setState({data_devices: payload.results.list})
                            }
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                    }
                }
                self.setState({flag_processing_search: false})
            })
    }

    render() {
        let self = this
    	let data = this.props.data

    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={false}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '600px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            DAFTAR DEVICE AGEN
	                        </h5>
	                    </div>
	                    <div className="modal-body" style={{padding: '15px 0'}}>
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">
                                        <div className="m-card-profile__pic">
                                            <div className="m-card-profile__pic-wrapper" style={{textAlign: 'center'}}>
                                                <img src={data.photo_url.length !== 0 ? data.photo_url : photo_default} style={{width:100+'px',height:100+'px'}}/>
                                            </div>
                                        </div>
                                        <div className="m-card-profile__details" style={{textAlign: 'center', marginTop:5+'px'}}>
                                            <span style={{fontWeight: '500',margin: '0 7px'}} className="">
                                                {data.agent_name} ({data.agent_id})
                                            </span>
                                        </div>
                                        
                                        <div className="m-form__group row" style={{margin: '20px 10px 10px 10px',borderBottom:'1px dashed rgb(235, 237, 242)',paddingBottom:'17px'}}>
                                            <div className="col-lg-9" style={{padding: 0}}>
                                                <input onChange={(e) => this.setState({search_input: e.target.value})}
                                                    type="text"
                                                    className="form-control m-input"
                                                    placeholder="Device ID"
                                                    name="search_input"
                                                    value={this.state.search_input}
                                                    style={{padding: '7px'}}/>
                                            </div>
                                            <div className="col-lg-3" style={{paddingRight: 0}}>
                                                <button onClick={(e) => this.on_btn_search(e)} className={this.state.flag_processing_search ? 'btn btn-primary m-btn m-btn--bolder m-loader m-loader--secondary m-loader--right' : 'btn btn-primary m-btn  m-btn--bolder'} style={{fontSize:'small',paddingTop:'7px',paddingBottom:'7px'}}>Search</button>
                                                &nbsp;&nbsp;&nbsp;
                                                {!this.state.flag_processing_search ? <button onClick={(e) => this.setState({show_add_form: !this.state.show_add_form})} className='btn btn-secondary m-btn m-btn--bolder' style={{fontSize:'small',padding:'7px 11px'}}>{this.state.show_add_form ? '-' : '+'}</button> : ''}
                                            </div>
                                        </div>

                                        {this.state.show_add_form ?
                                            <div style={{margin:'17px 10px 10px 10px',borderBottom:'1px dashed rgb(235, 237, 242)',paddingBottom:'17px'}}>
                                                <div className="m-form__group row" style={{marginBottom: '10px'}}>
                                                    <label className="col-lg-3" style={{fontWeight: 600, textAlign: 'left',color: '#575962',margin: 'auto'}}>
                                                        Platform:
                                                    </label>
                                                    <div className="col-lg-9">
                                                        <select className="m-input" id="platform" value={this.state.platform} onChange={(e) => this.on_select_change(e)} style={{height: '2.2rem', fontSize: '15px', borderColor: '#ebedf2', color: '#575962', background: '#fff', WebkitAppearance: 'none', padding: '0 10px'}}>
                                                        <option value="DESKTOP">DESKTOP</option>
                                                    </select>
                                                    </div>
                                                </div>
                                                <div className="m-form__group row" style={{marginBottom: '10px'}}>
                                                    <label className="col-lg-3" style={{fontWeight: 600, textAlign: 'left',color: '#575962',margin: 'auto'}}>
                                                        Device ID:
                                                    </label>
                                                    <div className="col-lg-9">
                                                        <input onChange={(e) => this.setState({device_id: e.target.value})}
                                                            type="text"
                                                            className="form-control m-input"
                                                            name="device_id"
                                                            value={this.state.device_id}
                                                            style={{padding: '5px'}}/>
                                                    </div>
                                                </div>
                                                <div className="m-form__group row" style={{marginBottom: '10px'}}>
                                                    <label className="col-lg-3" style={{fontWeight: 600, textAlign: 'left',color: '#575962',margin: 'auto'}}>
                                                        Device Info:
                                                    </label>
                                                    <div className="col-lg-9">
                                                        <input onChange={(e) => this.setState({device_info: e.target.value})}
                                                            type="text"
                                                            className="form-control m-input"
                                                            name="device_info"
                                                            value={this.state.device_info}
                                                            style={{padding: '5px'}}/>
                                                    </div>
                                                </div>
                                                <div className="m-form__group row" style={{marginBottom: '10px'}}>
                                                    <label className="col-lg-3" style={{fontWeight: 600, textAlign: 'left',color: '#575962',margin: 'auto'}}>
                                                        Status:
                                                    </label>
                                                    <div className="col-lg-9">
                                                        <select className="m-input" id="device_status" value={this.state.device_status} onChange={(e) => this.on_select_change(e)} style={{height: '2.2rem', fontSize: '15px', borderColor: '#ebedf2', color: '#575962', background: '#fff', WebkitAppearance: 'none', padding: '0 10px'}}>
                                                        <option value="1">Aktif</option>
                                                        <option value="0">Tidak Aktif</option>
                                                    </select>
                                                    </div>
                                                </div>
                                                <button onClick={(e) => this.on_add_device(e)} className={this.state.flag_processing ? 'btn btn-secondary m-btn--bolder m-loader m-loader--primary m-loader--right' : 'btn btn-primary m-btn  m-btn--bolder'} style={{fontSize: 'small',paddingTop:'7px',paddingBottom:'7px',display:'flex',marginLeft:'auto'}}>Tambah</button>  
                                            </div>
                                        : ''}
                                        <div className="m-widget4">
                                            {this.state.data_devices.length !== 0 && this.state.data_devices !== undefined ?
                                                this.state.data_devices.map(function(item, key) {
                                                    let icon = 'fa fa-television'
                                                    if (item.platform.toLowerCase() === 'web') {
                                                        icon = 'fa fa-connectdevelop'
                                                    } else if (item.platform.toLowerCase() === 'android') {
                                                        icon = 'fa fa-android'
                                                    }
                                                    return (
                                                        <div key={key} className="m-widget4__item" style={{paddingLeft:'15px',paddingRight:'10px'}}>
                                                            <div className="m-widget4__img m-widget4__img--pic">
                                                                <i className={icon}></i>
                                                        </div>
                                                        <div className="m-widget4__info">
                                                            <span className="m-widget4__title">
                                                                {item.device_info && item.device_info.length !== 0 ? item.device_info : item.platform}
                                                            </span>
                                                            <br/>
                                                            <div className="m-widget4__sub">
                                                                <span style={{}}>{item.device_id}</span>
                                                            </div>
                                                        </div>
                                                        <div className="m-widget4__ext" style={{display: 'flex',marginTop: '5px'}}>
                                                            <div className="dropdown">
                                                                <button onClick={(e) => self.on_btn_status(e, item)} className="btn btn-secondary" type="button" style={{padding:'5px 10px',height: '30px'}}>
                                                                    {item.active ? 'AKTIF' : 'TIDAK AKTIF'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )}) 
                                            : <div style={{textAlign: 'center'}}>{this.state.error_message}</div>}
                                            {this.state.show_more_btn ? <button type="button" style={{width:'-webkit-fill-available',margin:'10px 10px 0 10px'}} onClick={this.on_btn_load_more} className={this.state.tx_flag_processing ? 'btn btn-secondary m-loader m-loader--primary m-loader--right' : 'btn btn-secondary'}>
                                                Load More
                                            </button> : ''}
                                        </div>
			                        </div>
			                    </div>
				            </div>
	                    </div>
	                    <div className="modal-footer" style={{borderTop: 0, display:'none'}}></div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    balance: state.Balance,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalDevice)



// WEBPACK FOOTER //
// ./src/component/form/dialog_device.js